/** Request identities are transport metadata, never narration or user content. */
export function createRequestId(): string {
  const bytes = crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, (value) =>
    value.toString(16).padStart(2, '0'),
  ).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

/** Keep a failed draft's key until it succeeds or its canonical payload changes. */
export class DraftRequestKey {
  private pending: { payload: string; key: string } | null = null;

  forPayload(payload: string): string {
    if (this.pending?.payload !== payload)
      this.pending = { payload, key: createRequestId() };
    return this.pending.key;
  }

  complete(key: string): void {
    if (this.pending?.key === key) this.pending = null;
  }
}
